<template>
  <span>
    <el-input
      placeholder="请输入"
      maxlength="4"
      style="width: 80px"
      :value="this.arrData[0]"
      @input="handleInputMin"
    ></el-input>
    <span class="s-sep"> - </span>
    <el-input
      placeholder="请输入"
      maxlength="4"
      style="width: 80px"
      :value="this.arrData[1]"
      @input="handleInputMax"
    ></el-input>
  </span>
</template>
<script>
export default {
  model: {
  prop:"arrData",
    event: "change",
  },
  props: {
    arrData: { type: Array, default: () => ["", ""] },
  },

  data() {
    return {
      first: this.arrData[0],
      last: this.arrData[1]
    };
  },
  methods: {
    handleInputMin() {
      const value = event.target.value;
      if (!this.isNumber(value)) {
        return;
      }
      this.first = value;
     /* if (value > this.last) {
        this.first = this.last;
      }*/
      var arr = [this.first, this.last];
      this.$emit("change", arr);  
    },
    handleInputMax() {
      const value = event.target.value;
      if (!this.isNumber(value)) {
        return;
      }
      this.last = value;
      // if (value < this.first) {
        // this.last = this.first;
      // }
      var arr = [this.first, this.last];
      this.$emit("change", arr); // key code
    },

    isNumber(val) {
      var numReg = /^[0-9]*$/;
      var numRe = new RegExp(numReg);
      if (!numRe.test(val)) {
        return false;
      }
      return true;
    },
  },
  watch: {
    arrData(newValue) {
     // alert(JSON.stringify(newValue));
      var val = newValue;
      if(!newValue || newValue.length<2)
      {
        val = ["",""];
      }

       this.$emit('change',val);
    },
  },
};
</script>